import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import unavailableHeavyProducts from '~/const/patch';
var COLORS = {
  IN_STOCK: 'green',
  UNAVAILABLE: 'red',
  SOON: 'orange',
  MONTH: 'orange',
  WEEK: 'orange',
  LIMITED: 'orange',
  STORE_ONLY: 'black',
  DELETE: 'white',
  default: 'black'
};
export default {
  name: 'ProductStock',
  props: {
    stock: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showOnlyInStock: {
      type: Boolean,
      default: false
    },
    reference: {
      type: String,
      default: ''
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    currentStock: function currentStock() {
      if (this.stock.status === 'STORE_ONLY' && unavailableHeavyProducts(this.reference, this.locale.iso)) {
        return this.$t('unavailable');
      }

      return this.stock.message || this.$t('IN_STOCK');
    },
    color: function color() {
      return COLORS[this.stock.status] || COLORS.default;
    }
  })
};